import { useMemo } from "react";

import type { IGetMarketsByEventIdRequestParams } from "~/feature/dashboard/types";
import {
  hasEventMarketsFilterParams,
  requestParamsFromEventMarketsFilters,
} from "~/feature/event/components/MarketsDataGrid/requestParamsFromEventMarketsFilters";
import { useEventMarketsFilter } from "~/feature/event/providers/EventMarketsFiltersProvider";
import { useEventMarketsSettings } from "~/feature/event/providers/EventMarketsSettingsProvider";

export const useMarketsDataGridFilters =
  (): Partial<IGetMarketsByEventIdRequestParams> => {
    const { ungroup } = useEventMarketsSettings();
    const { filters } = useEventMarketsFilter();

    return useMemo(
      () => requestParamsFromEventMarketsFilters(filters, ungroup),
      [filters, ungroup]
    );
  };

export const useHasMarketsDataGridFilters = (): boolean => {
  const backendFilterParams = useMarketsDataGridFilters();

  return useMemo(
    () => hasEventMarketsFilterParams(backendFilterParams),
    [backendFilterParams]
  );
};
